import { z } from "zod";

export const isoDate = z.string().datetime({ offset: true });
export const optionalIsoDate = z.string().datetime({ offset: true }).nullable().optional();

export const channelCode = z
  .string()
  .trim()
  .min(1)
  .max(60)
  .regex(/^[A-Z][A-Z0-9_]*$/, "A channel code must be uppercase letters, digits, and underscores.");

export function validateTargeting(
  value: {
    appliesToAllChannels: boolean;
    appliesToAllCategories: boolean;
    channels?: Array<{ channelId: string }>;
    categoryIds?: string[];
  },
  ctx: z.RefinementCtx,
) {
  if (!value.appliesToAllChannels && (value.channels ?? []).length === 0) {
    ctx.addIssue({
      code: "custom",
      path: ["channels"],
      message: "Select at least one channel, or apply the item to all channels.",
    });
  }
  if (!value.appliesToAllCategories && (value.categoryIds ?? []).length === 0) {
    ctx.addIssue({
      code: "custom",
      path: ["categoryIds"],
      message: "Select at least one category, or apply the item to all categories.",
    });
  }
}
